import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const NotFound = lazy(() => import('../../container/pages/404'));
const FormsPage = lazy(() => import('../../container/modules/filer/forms'))
const EditForm = lazy(() => import('../../container/modules/company/forms/edit/EditForm'))
const Profile = lazy(() => import('../../container/modules/profile'))

function PagesRoute() {
  return (
    <Routes>
      <Route path="*" element={<NotFound />} />
      <Route path="profile" element={<Profile />} />
      <Route path="forms" element={<FormsPage />} />
      <Route path="forms/edit" element={<EditForm />} />
    </Routes>
  );
}

export default PagesRoute;
